import Vue from "vue";

import bootstrapVueDefaults from "@/config/bootstrapVueDefaults.js";

// vue-bootstrap
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
Vue.use(BootstrapVue, bootstrapVueDefaults);
Vue.use(IconsPlugin);

// Icons
import feather from "vue-icon";
Vue.use(feather, "v-icon");

//vue wysiwyg
import wysiwyg from "vue-wysiwyg";
import "vue-wysiwyg/dist/vueWysiwyg.css";
Vue.use(wysiwyg, {
  locale: "es",
  image: {
    uploadURL: process.env.VUE_APP_ENDPOINT + "/imagen/subir",
  },
});

// Date Picker
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";
Vue.component("date-picker", DatePicker);

// Vue-loading
import PageLoading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
Vue.component("page-loading", PageLoading);

// DayJS
import dayjs from "dayjs";
import "dayjs/locale/es";
dayjs.locale("es");

//paginate
import VuejsPaginate from "vuejs-paginate";
Vue.component("paginate", VuejsPaginate);

import Paginacion from "@/components/Paginacion";
Vue.component("paginacion", Paginacion);

// Select2
// para el menu de aplicaciones porque vue-select no soporta optgroup
import Select2 from "@/components/Select2.vue";
import "./styles/select2_bootstrap_theme.css";
Vue.component("v-select2", Select2);

//multiselect
import Select2MultipleControl from "v-select2-multiple-component";
Vue.component("Select2MultipleControl", Select2MultipleControl);

//layout
import PageHeader from "@/components/PageHeader.vue";
Vue.component("PageHeader", PageHeader);

import PageEdicion from "@/components/PageEdicion.vue";
Vue.component("PageEdicion", PageEdicion);

import PageListado from "@/components/PageListado.vue";
Vue.component("PageListado", PageListado);

import BotoneraEdicion from "@/components/BotoneraEdicion.vue";
Vue.component("BotoneraEdicion", BotoneraEdicion);

import SinRegistros from "@/components/SinRegistros.vue";
Vue.component("SinRegistros", SinRegistros);

import BusquedaRapida from "@/components/BusquedaRapida.vue";
Vue.component("BusquedaRapida", BusquedaRapida);

import ThOrdenado from "@/components/ThOrdenado.vue";
Vue.component("ThOrdenado", ThOrdenado);

import SelectBox from "@/components/SelectBox.vue";
Vue.component("SelectBox", SelectBox);

import ComboMultiple from "@/components/ComboMultiple.vue";
Vue.component("ComboMultiple", ComboMultiple);

import BotonEliminar from "@/components/BotonEliminar.vue";
Vue.component("BotonEliminar", BotonEliminar);

import CampoImagen from "@/components/CampoImagen.vue";
Vue.component("CampoImagen", CampoImagen);

import CampoFicheroMultiple from "@/components/CampoFicheroMultiple.vue";
Vue.component("CampoFicheroMultiple", CampoFicheroMultiple);

import TreeItem from "@/components/TreeItem.vue";
Vue.component("TreeItem", TreeItem);

import BoolCheck from "@/components/BoolCheck.vue";
Vue.component("BoolCheck", BoolCheck);

import RowMenu from "@/components/RowMenu.vue";
Vue.component("RowMenu", RowMenu);

import RowMenuItem from "@/components/RowMenuItem.vue";
Vue.component("RowMenuItem", RowMenuItem);

import RowMenuDivider from "@/components/RowMenuDivider.vue";
Vue.component("RowMenuDivider", RowMenuDivider);

import messages from "@/plugins/MessagesPlugin";
Vue.use(messages);

import backend from "@/plugins/BackendPlugin";
Vue.use(backend);
